module.exports = __webpack_public_path__ + "img/yacht.53bea4db.png";